import React from 'react';
import './Landing.css';

function Landing() {
  const achievements = [
    { text: "Designed multi-agent AI pipelines processing millions of data points" },
    { text: "Built enterprise RAG systems for Fortune 500 clients" },
    { text: "Developed ML platform reducing operational costs by 40%" },
    { text: "Led conversational AI interfaces using LLMs and voice tech" },
    { text: "Created automated data quality monitoring with anomaly detection" },
    { text: "Judge at UNC School of Data Science for NLP projects" },
    { text: "Turing Minds Coordinator – organize AI symposiums" },
    { text: "Open source contributor to ML frameworks and ethical AI" }
  ];

  const blogs = [
    {
      title: "Building Conversational AI with LangChain",
      date: "Oct 20, 2024",
      excerpt: "Learn how to create powerful AI agents using LangChain and modern LLMs.",
      readTime: "7 min read"
    },
    {
      title: "The Art of Prompt Engineering",
      date: "Oct 5, 2024",
      excerpt: "Mastering the techniques to get the best responses from AI models.",
      readTime: "5 min read"
    },
    {
      title: "Deploying ML Models at Scale",
      date: "Sep 22, 2024",
      excerpt: "Best practices for deploying and monitoring machine learning models in production.",
      readTime: "10 min read"
    }
  ];

  return (
    <div className="landing-container">
      <div className="grid-background"></div>
      
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          {/* Profile Header with Image and Name */}
          <div className="profile-header">
            <div className="profile-image">
              <img src="/deepak_pp.jpeg" alt="Deepak Dhaka" />
            </div>
            <h1 className="profile-name">deepak dhaka</h1>
          </div>
          
          {/* Bio */}
          <p className="profile-bio">
            Senior Machine Learning Engineer at LTIMindtree. Building innovative AI/ML solutions that bridge humans and technology.
          </p>
          
          {/* Social Links */}
          <div className="hero-social-links">
            <a href="https://github.com/dhakadeepak" target="_blank" rel="noopener noreferrer" className="hero-social-link">
              GitHub
            </a>
            <a href="https://www.linkedin.com/in/deepakdhaka/" target="_blank" rel="noopener noreferrer" className="hero-social-link">
              LinkedIn
            </a>
            <a href="https://twitter.com/dhaka_22" target="_blank" rel="noopener noreferrer" className="hero-social-link">
              X
            </a>
            <a href="mailto:deepak@example.com" className="hero-social-link" onClick={(e) => {
              e.preventDefault();
              navigator.clipboard.writeText('d.dhaka2210@gmail.com');
              alert('Email copied to clipboard!');
            }}>
              Copy email
            </a>
          </div>

          {/* Achievements Timeline */}
          <div className="achievements-container">
            <ul className="achievements-list">
              {achievements.map((achievement, index) => (
                <li key={index} className="achievement-item">
                  <span className="achievement-bullet">•</span>
                  <span className="achievement-text">{achievement.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Blogs Section */}
      <section className="blogs-section">
        <h2 className="section-title">Recent Blogs</h2>
        <div className="blogs-list">
          {blogs.map((blog, index) => (
            <article key={index} className="blog-item">
              <div className="blog-content">
                <h3 className="blog-title">{blog.title}</h3>
                <p className="blog-excerpt">{blog.excerpt}</p>
                <div className="blog-meta">
                  <span className="blog-date">{blog.date}</span>
                  <span className="blog-separator">•</span>
                  <span className="read-time">{blog.readTime}</span>
                </div>
              </div>
              <button className="read-more-btn">→</button>
            </article>
          ))}
        </div>
      </section>

      {/* Floating decorative elements */}
      <div className="decorative-dots">
        <span className="dot dot-1"></span>
        <span className="dot dot-2"></span>
        <span className="dot dot-3"></span>
        <span className="dot dot-4"></span>
      </div>
    </div>
  );
}

export default Landing;
